import { Button, ButtonRow, Heading, TextArea } from '@ksyos/design-system';
import type { IStepProps } from '../OsasPatientQuestionnaire';
import { translateKey } from '../../../../../translate';
import { CustomContainer } from '../../../../elements/molecules/customContainer/CustomContainer';
import { Stack } from '../../../../elements/molecules/stack/Stack';
import { StyledFormGroup } from '../../../../elements/organisms/StyledFormGroup/StyledFormGroup';
import { ScoreInput } from './ScoreInput';

export function Step3(props: IStepProps) {
    return (
        <>
            <CustomContainer>
                <Stack>
                    <Heading size="large">Rapportcijfer</Heading>
                </Stack>

                <ScoreInput
                    error={props.errors.get('scoreKsyosSleep')}
                    handleChange={(value) => props.handleChange({ scoreKsyosSleep: value })}
                    question="Welk cijfer geef je aan Ksyos Slaap?"
                    value={props.customControlData.scoreKsyosSleep}
                />

                <ScoreInput
                    error={props.errors.get('repeatDigitalExamination')}
                    handleChange={(value) => props.handleChange({ repeatDigitalExamination: value })}
                    question="Zou je op basis van je ervaring nogmaals een digitaal onderzoek doen?"
                    value={props.customControlData.repeatDigitalExamination}
                />

                <Stack>
                    <StyledFormGroup
                        hasErrors={props.errors.has('scoreFreeText')}
                        label="Toelichting (optioneel)"
                        layout="vertical"
                    >
                        <TextArea
                            autoResize
                            error={
                                props.errors.get('scoreFreeText')
                                    ? translateKey('validation.' + props.errors.get('scoreFreeText'))
                                    : undefined
                            }
                            onChange={(e) => {
                                const scoreFreeText = e.target.value !== '' ? e.target.value : null;
                                props.handleChange({ scoreFreeText });
                            }}
                            placeholder="Wil je nog iets kwijt? Vermeld geen persoonlijke gegevens..."
                            value={props.customControlData.scoreFreeText || ''}
                        />
                    </StyledFormGroup>
                </Stack>

                <ButtonRow justify="right">
                    <Button
                        color="secondary"
                        onClick={props.goToPreviousStep}
                        variant="outline"
                    >
                        Terug
                    </Button>
                    <Button
                        color="secondary"
                        onClick={props.validateAndGoToNextStep}
                        variant="solid"
                    >
                        Ga verder
                    </Button>
                </ButtonRow>
            </CustomContainer>
        </>
    );
}
